import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Select } from 'antd';
import { useDesksConfigs } from '../../services/desksConfigs';
import { useSetFormValues } from '../../services/setFormValues';
import Field from '../../../../shared/ui/Field';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { actionCreators, sliceKeys } from '../../../../model';
import styles from './index.module.scss';

const { activeDeskIndexChanged } = actionCreators[sliceKeys.desks];

const SelectConfig = () => {
  const dispatch = useDispatch();

  const configs = useDesksConfigs();

  const setFormValues = useSetFormValues();

  const setConfigValues = useCallback(
    (config) => {
      setFormValues(config);
      dispatch(activeDeskIndexChanged(0));
    },
    [setFormValues, dispatch]
  );

  useEffect(() => {
    if (configs.size === 1) {
      setConfigValues(configs.getFirstConfig());
    }
  }, [configs, setConfigValues]);

  return configs.size > 1 ? (
    <ChangeConfig configs={configs} setConfigValues={setConfigValues} />
  ) : null;
};

export default SelectConfig;

function ChangeConfig({ configs, setConfigValues }) {
  const { field, fieldState } = useFieldController({
    name: fieldNames.main.configId,
    rules: { required: 'Выберите конфигурацию' },
  });

  const handleChange = (value) => {
    setConfigValues(configs.getConfigById(value));
  };

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel="Кофигурация"
      required
      value={field.value}
      onChange={handleChange}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      style={{ width: '100%' }}
      rootCN={styles.select}
    >
      {configs.configOptions.map((item) => (
        <Select.Option value={item.value} key={item.key}>
          {item.label}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
}
